import React, { useContext, useState, useEffect } from 'react'

import { useHistory } from 'react-router-dom'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { handleRedirectInternal } from '@/product/common/components'
import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import SettingContext from '@/product/context/setting/settingContext'
import GiftContext from '@/product/context/giftCard/giftContext'
import CouponManage from './view'
import CustomDialog from '@/product/components/organisms/Dialog'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
const GiftView = (props) => {
    const [isLoading, setIsLoading] = useState(true)
    const [couponID, setCouponID] = useState(0)
    const alertContext = useContext(AlertContext)
    const settingContext = useContext(SettingContext)
    const giftContext = useContext(GiftContext)
    const [changeStatus, setChangeStatus] = useState(false)
    const history = useHistory()
    const { setAlert } = alertContext
    const {
        getAllGiftCards,
        search_allgiftcards,
        giftCardAction,
        responseStatus: responseStatusGift,
        clearResponse,
    } = giftContext
    const {
        configurations,
        getAllConfigurations,
        responseStatus: responseStatusCommuncation,
    } = settingContext

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const formik = useFormik({
        initialValues: {
            searchterm: '',
            page: 1,
            limit: 20,
            order: '',
            filters: true,
            orderby: '',
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllGiftCards(values)
        },
    })

    useEffect(() => {
        if (search_allgiftcards) {
            console.log(search_allgiftcards, 'search_allgiftcards')
            setTableBody(
                search_allgiftcards.records.length
                    ? search_allgiftcards.records
                    : []
            )
            setIsLoading(false)
        }
    }, [search_allgiftcards])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.page = 1
        formik.values.searchterm = ''
        getAllGiftCards(formik.values)
        /*  return () => {
            setTableBody([])
        }*/
    }, [])

    useEffect(() => {
        if (responseStatusGift) {
            if (
                (responseStatusGift.from === 'giftCardAction' ||
                    responseStatusGift.from === 'delete') &&
                responseStatusGift.status === 'success'
            ) {
                toggleFullScreenPopup(false)
                setTableBody([])
                formik.values.page = 1
                formik.values.searchterm = ''
                getAllGiftCards(formik.values)
                if (responseStatusGift.from === 'delete') {
                    changeChangeStatus()
                    setAlert('Deleted Successfully', 'success')
                }
            }
        }
    }, [responseStatusGift])

    const onClickEdit = (id, secondaryID, type) => {
        if (type == 'edit') {
            toggleFullScreenPopup(true, 'edit', id)
        } else {
            setCouponID(id)
            changeChangeStatus()
        }
    }
    const getMultipleAction = () => {
        let actionPush = [
            {
                buttonType: 'edit',

                onclick: onClickEdit,
                clickType: 'edit',
                tooltipTitle: 'Edit Gift Card',
            },
            {
                buttonType: 'delete',

                onclick: onClickEdit,
                clickType: 'delete',
                tooltipTitle: 'Delete Gift Card',
            },
        ]
        // actionPush.push({
        //     buttonType: 'edit',

        //     onclick: onClickEdit,
        //     clickType: 'edit',
        //     tooltipTitle: 'Edit Coupon',
        // })

        return actionPush
    }
    const tableValues = [
        {
            field: 'code',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Gift Card Code',
            filterable: true,
            filterField: 'code',
        },
        {
            field: 'start_date',
            type: 'datetime',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Gift Card Start',
            filterable: true,
            filterField: 'start_date',
        },
        {
            field: 'end_date',
            type: 'datetime',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Gift Card End',
            filterable: true,
            filterField: 'end_date',
        },

        {
            field: 'discount',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Gift Card Amount',
            // filterable: true,
            // filterField: 'discount',
        },
        {
            field: 'discount_type',
            type: 'capitalize',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Gift Card Type',
            // filterable: true,
            // filterField: 'discount',
        },
        // {
        //     field: 'apply_for',
        //     type: 'singleSelect',
        //     firstChild: true,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Coupon Apply For',
        //     valueOptions: ['both', 'use_credit', 'registration'],
        //     filterable: true,
        //     filterField: 'apply_coupon',
        // },
        {
            field: 'created_at',
            type: 'date',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Gift Card Created',
        },
        // {
        //     field: 'total_count',
        //     type: '',
        //     firstChild: true,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Total Times Used',
        // },
        {
            field: 'description',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Gift Card Notes',
        },
        {
            field: 'action',
            type: 'button',

            isMultiple: true,
            isMultiple: getMultipleAction(),
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
        },
    ]

    // const searchInfo = [
    //     {
    //         label: 'Settings',
    //         placeholder: 'Enter Settings Title',
    //         class: 'col-md-4 col-sm-6 col-12',
    //         type: 'text',
    //         name: 'searchterm',
    //         formik: formik,
    //     },
    // ]
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }
    const submitFn = () => {
        giftCardAction(
            {
                id: couponID,
                enabled: 2,
            },
            'delete'
        )
        setIsLoading(true)
    }
    return (
        <Layout>
            <div className="dashboard staticPages">
                {/* <CustomSearch searchInfo={searchInfo} formik={formik} /> */}
                <div className="d-flex justify-content-between align-items-center mt-4 mb-3">
                    <Button
                        id="configView_variable_new"
                        variant="outlined"
                        className="btnOutlined"
                        onClick={() => toggleFullScreenPopup(true, 'new', 0)}
                    >
                        <span className="material-icons">note_add</span>Add Gift
                        Card
                    </Button>
                </div>
                <CustomTable
                    formik={formik.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={[]}
                    allData={search_allgiftcards}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={getAllGiftCards}
                />
            </div>
            <CouponManage
                data={manage}
                function={toggleFullScreenPopup}
                noExpiry={props?.noExpiry || false}
            />
            <CustomDialog
                title={'Change Gift Card status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to change the status ?</h5>

                <div className="actionWrapper">
                    <Button
                        id="invoice_cancel"
                        onClick={() => setChangeStatus(false)}
                    >
                        Cancel
                    </Button>

                    <PrimaryButton
                        onClick={submitFn}
                        id="invoice_confirm"
                        label="Confirm"
                    />
                </div>
            </CustomDialog>
        </Layout>
    )
}
export default GiftView
